import { use, useMemo } from 'react'
import { CompanySuspensionContext } from '@/components/company-suspension/context'
import { QueryRefsContext } from '@/components/root/query-refs-context'
import { useReadQuery } from '@/lib/hooks'

export const CompanySuspensionProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { companySuspensionQueryRef } = use(QueryRefsContext)

  const { data } = useReadQuery(companySuspensionQueryRef)

  const isSuspended = useMemo(() => {
    return data?.company?.sevallaBilling?.isSuspended ?? false
  }, [data])

  const suspensionReason = useMemo(() => {
    return data?.company?.sevallaBilling?.suspensionReason ?? null
  }, [data])

  return (
    <CompanySuspensionContext.Provider
      value={{ isSuspended, suspensionReason }}
    >
      {children}
    </CompanySuspensionContext.Provider>
  )
}
